/* import __COLOCATED_TEMPLATE__ from './customizable-quick-replies.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();